var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4999 7.10712C9.39251 7.10712 8.49231 8.00802 8.49231 9.11612C8.49231 10.2235 9.39251 11.1237 10.4999 11.1237C11.6073 11.1237 12.5068 10.2235 12.5068 9.11612C12.5068 8.00802 11.6073 7.10712 10.4999 7.10712",
    fill: "#F58B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0273 10.6939C13.0606 12.8079 11.2077 15.0416 10.6631 15.6751C10.6218 15.722 10.5637 15.75 10.5 15.75C10.4377 15.75 10.3768 15.722 10.3383 15.6751C9.7923 15.0416 7.9394 12.8079 6.9727 10.6939C6.7494 10.2025 6.6346 9.6712 6.6346 9.1161C6.6346 6.9839 8.3692 5.25 10.5 5.25C12.6315 5.25 14.3654 6.9839 14.3654 9.1161C14.3654 9.6712 14.252 10.2025 14.0273 10.6939ZM10.5 0C4.7012 0 0 4.7012 0 10.5C0 16.2988 4.7012 21 10.5 21C16.2995 21 21 16.2988 21 10.5C21 4.7012 16.2995 0 10.5 0V0Z",
    fill: "#F58B7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRound);
export default __webpack_public_path__ + "static/media/location-round.78f4ee4e31c3be261ff53d1f799fe840.svg";
export { ForwardRef as ReactComponent };